import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClearOutlined, DownOutlined, LoadingOutlined, } from "@ant-design/icons";
import { Button, Space } from "antd";
/**
 * Рендерер на основе Button
 * Показывает количество выбранных элементов и первые несколько названий
 */
export const ButtonRenderer = ({ disabled, loading, style, className, hasSelection, selectedItems, placeholder, onClick, onClear, }) => {
    const getButtonText = () => {
        if (loading)
            return "Загрузка...";
        if (!hasSelection)
            return placeholder || "Выберите элемент";
        if (selectedItems.length === 1) {
            return selectedItems[0].label;
        }
        return `Выбрано: ${selectedItems.length}`;
    };
    const getButtonIcon = () => {
        if (loading)
            return _jsx(LoadingOutlined, { spin: true });
        return _jsx(DownOutlined, {});
    };
    return (_jsx("div", { style: style, className: className, children: _jsxs(Space.Compact, { style: { width: "100%" }, children: [_jsx(Button, { disabled: disabled, onClick: onClick, style: { flex: 1, textAlign: "left" }, icon: getButtonIcon(), iconPosition: "end", children: getButtonText() }), hasSelection && onClear && (_jsx(Button, { disabled: disabled, onClick: onClear, icon: _jsx(ClearOutlined, {}), style: { flexShrink: 0 } }))] }) }));
};
